/**
 * Builder Card Carousel Handler
 * Manages builder card carousel initialization on the state search results page.
 * Follows the same pattern as articleCardCarousel but for builder cards.
 */
import Carousel from '@components/carousel/dynamicCarousel';

/**
 * Initializes a carousel for a builder card section.
 *
 * @param {string} carouselQuerySelector - The CSS selector for the carousel container element.
 */
const setBuilderCardCarousel = (carouselQuerySelector) => {
  const carouselSettings = {
    itemListQuerySelector: `${carouselQuerySelector} [data-item-list]`,
    previousQuerySelector: `${carouselQuerySelector} [data-left-arrow]`,
    nextQuerySelector: `${carouselQuerySelector} [data-right-arrow]`,
  };
  
  const carousel = new Carousel();
  carousel.setSettings(carouselSettings);
  carousel.create();
};

/**
 * Initializes all builder card carousels on the page.
 * Searches for elements with the data-builder-card-carousel attribute
 * and initializes a carousel for each one.
 */
const initializeBuilderCardCarousels = () => {
  const builderCarouselElements = document.querySelectorAll('[data-builder-card-carousel]');

  builderCarouselElements.forEach((carouselElement) => {
    const carouselIdentifier = carouselElement.getAttribute('data-builder-card-carousel');
    if (!carouselIdentifier) {
      return;
    }

    const carouselQuerySelector = `[data-builder-card-carousel="${carouselIdentifier}"]`;
    setBuilderCardCarousel(carouselQuerySelector);
  });
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBuilderCardCarousels);
} else {
  initializeBuilderCardCarousels();
}

export default initializeBuilderCardCarousels;
